import { ApiDimension, ApiChartAttribute } from "@incendium/api";
import { Box } from "@mui/material";
import RetentionMetricsOverTime from "features/analytics/components/RetentionMetricsOverTime";
import { CustomerRetentionCohortProvider } from "features/analytics/context/CustomerRetentionCohortProvider";
import CustomerRetentionTable from "features/analytics/components/CustomerRetentionTable";

interface ICustomerTabProps {
  attributes: ApiChartAttribute[];
}

function CustomerTab({ attributes }: ICustomerTabProps) {
  return (
    <CustomerRetentionCohortProvider>
      <Box sx={{ height: 450, flexShrink: 0 }}>
        <RetentionMetricsOverTime
          staticRetentionWindowDays={90}
          staticGranularity={ApiDimension.DIMENSION_SESSION_START_BY_WEEK}
          attributes={attributes}
        />
      </Box>
      <Box sx={{ height: 600, flexShrink: 0 }}>
        <CustomerRetentionTable />
      </Box>
    </CustomerRetentionCohortProvider>
  );
}

export default CustomerTab;
